import React from "react";
import "./Card.css";

const Card = props => {
  return (
    <div className="card text-center d-inline-block general-card-wrapper">
      <div className="card-header general-card-header">
        <h5>{props.header}</h5>
      </div>
      <div className="card-body">
        <p className="card-text">{props.body}</p>
      </div>
    </div>
  );
};

export default Card;
